import React from 'react'
import { Container, Row, Col } from 'react-bootstrap-v5'
import './MapaFDNA.css'

const MapaFDNA: React.FC = () => {
  return (
    <Container fluid className='mapa-fdna-container'>
      <Row className='mapa-fdna-row'>
        <Col xs={12} md={12} className='mapa-fdna-col'>
          <div className='mapa-wrapper'>
            <h3 className='mapa-title mb-4'>Mapa de Sedes FDNA</h3>
            <p className='mapa-subtitle mb-4'>
              Visualiza la distribución geográfica de las sedes oficiales.
            </p>
            <img
              src='/media/logos/MAPA_FDNA.svg'
              alt='Mapa de sedes FDNA'
              className='mapa-image'
            />
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default MapaFDNA
